import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit";
import { LIBRARY_SERVICE_METHOD, USER_SERVICES_METHOD } from "services/commonService";
import { apiRequest } from "services/ServiceUtil";

const SLICE = "ReleaseHighlights";

const isReleaseHighlightsThunk = (action: any) => action.type.startsWith(`${SLICE}/`); // This is to check fullfilled and rejected cases only for ReleaseHighlights Slice.

const initialState: any = {
  loadingCount: 0,
  isReleaseHighlightOpen: false,
  newInBoostResources: []
};

export const fetchBuzzCards = createAsyncThunk(`${SLICE}/fetchBuzzCards`, (data: any, thunkApi) => {
  return apiRequest(LIBRARY_SERVICE_METHOD.postCards, {}, thunkApi, ["buzz"]);
});

export const markBuzzAsViewed = createAsyncThunk(`${SLICE}/markBuzzAsViewed`, (data?: any, thunkApi?: any) => {
  return apiRequest(USER_SERVICES_METHOD.patchAssociatesMetadata, {}, thunkApi, [], {
    update_type: data?.update_type
  });
});

export const ReleaseHighlights = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: (state) => {
      return {
        ...initialState,
        newInBoostResources: state.newInBoostResources
      };
    },
    setReleaseHighlightDialog: (state, action) => {
      state.isReleaseHighlightOpen = action?.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBuzzCards.fulfilled, (state, action) => {
        state[action.meta.arg.hltId] = {
          releaseNotes:
            action.meta?.arg?.source === "api"
              ? action.payload.cards.filter((item: any) => item.latest)
              : action.payload.cards,
          showBuzzSection: !!action.payload.cards.length
        };
      })
      .addMatcher(
        (action) => isPending(action) && isReleaseHighlightsThunk(action),
        (state, action) => {
          if (
            // turn on loader if api is not paginated or it is for 1st page
            !("pagination" in action.meta.arg || "page" in action.meta.arg) ||
            action.meta?.arg?.pagination === 1 ||
            action.meta?.arg?.page === 0
          ) {
            state.loadingCount += 1;
          }
        }
      )
      .addMatcher(
        (action) => (isFulfilled(action) || isRejected(action)) && isReleaseHighlightsThunk(action),
        (state, action) => {
          if (
            !("pagination" in action.meta.arg || "page" in action.meta.arg) ||
            action.meta?.arg?.pagination === 1 ||
            action.meta?.arg?.page === 0
          ) {
            state.loadingCount -= 1;
          }
        }
      );
  }
});

export const { reset, setReleaseHighlightDialog } = ReleaseHighlights.actions;

export default ReleaseHighlights.reducer;
